import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Grid, Typography } from "antd";
import { DesktopOutlined } from "@ant-design/icons";
import GuidedEmailEditor from "./GuidedEmailEditor";

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

// The GrapesJS-based editor's toolbar/canvas chrome needs real screen real
// estate to be usable; below desktop widths we show a notice instead of
// mounting the (heavy) editor at all.
export default function QuickCampaignCreator() {
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const isDesktop = screens.lg === true;

  if (!isDesktop) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 64px)",
          padding: "2rem",
        }}
      >
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <DesktopOutlined style={{ fontSize: 40, marginBottom: 16 }} />
          <Title level={4}>Editor is available on desktop only</Title>
          <Paragraph type="secondary">
            The email editor needs a larger screen to work well. Please switch
            to a desktop or laptop computer to create or edit campaigns here.
          </Paragraph>
          <Button type="primary" onClick={() => navigate("/app/campaigns")}>
            Back to Campaigns
          </Button>
        </div>
      </div>
    );
  }

  return <GuidedEmailEditor />;
}
